import { Person, PeopleApi } from 'api'
import { Model } from 'api'
import { Formatter } from 'shared'
import { SmartButtonStub } from 'ui/smart-buttons'
import { Multiselect } from 'multiselect-react-dropdown';
import { SeatsioSeatingChart } from '@seatsio/seatsio-react/src/main';

export default class EventReservationBlock extends Component {
  constructor(props) {
    super(props)
    let { event } = this.props
    let defaultTicketTypeName = event.defaultTicketType && event.defaultTicketType.type
    this.state = { 
        tickets: event.event_id ? { } :{ [defaultTicketTypeName]: (event.isFamily ? 0 : 1) },
        selectedFamilyMembers: [],
        selectedSeats: {}
      }
  }

  get selectedOccurrenceId() {
    let { event, subroute } = this.props
    return Model.extractSubrouteArgs(subroute, 0) || event.hasReservableOccurrences && event.reservableOccurrences[0].id
  }

  render() {
    let { event, base, subroute } = this.props
    let { tickets, selectedFamilyMembers, selectedSeats } = this.state;
    let linked_users_json = PeopleApi.kick('linked_users', {})

    const seatingChartPricing = event.ticket_settings.map(setting => ({
      category: setting.type,
      price: setting.amount ? setting.amount/100 : 0
    }));

    const showSeatDetails = event.category === 'seated';

    // Calculate total price for each category
    const seatCategories = Object.keys(selectedSeats).map(category => {
      const seatCount = selectedSeats[category].length;
      const seatPriceCents = event.ticket_settings.find(setting => setting.type === category)?.amount || 0;
      const seatPriceDollars = seatPriceCents / 100;  // Convert price from cents to dollars
      const totalPrice = seatPriceDollars * seatCount;
      return {
        category,
        seats: selectedSeats[category],
        seatCount,
        totalPrice
      };
    });

    const subtotal = seatCategories.reduce((sum, category) => sum + category.totalPrice, 0);


    if (event.requiresPayment && !application.user.hasCard) return this.renderCardRequired()

    return (
      <div className="EventReservation-form">
        <h3 className="EventReservation-heading">Reservation Details</h3>
        {showSeatDetails && event.event_id &&
          <div style={{ 'height': '500px' }}>
            <SeatsioSeatingChart
              workspaceKey={event.workspace_key}
              event={event.event_id}
              region="na"
              onObjectSelected={this.onSeatSelected}     // Add seat selection handler
              onObjectDeselected={this.onSeatDeselected} // Add seat deselection handler
              pricing={seatingChartPricing}
              showLegend={true}  // Show/hide legend if needed
              showFullScreenButton={false}
              priceFormatter= {function(price) {
                  return '$' + price;
              }}
            />
          </div>
        }
        {showSeatDetails &&  event.event_id && (
          <div className="EventReservation-selected-seats-summary">
            <h4 className="EventReservation-selected-seats-summary-title">Selected Seats</h4>

            {seatCategories.length > 0 ? (
              <ul className="seat-list">
                {seatCategories.map((seat, index) => (
                  <li key={index} className="seat-item">
                    <span className="seat-number">{seat.category} : {seat.seats.join(', ')}</span>
                    {seat.totalPrice > 0 && <span className="seat-price">Price: ${seat.totalPrice.toFixed(2)}</span>}
                  </li>
                ))}
              </ul>
            ) : (
              <p className="EventReservation-selected-seats-summary-no-seats-selected">No seats selected.</p>
            )}

            <div className="EventReservation-selected-seats-summary-total-summary">
              <span className="total-label">Total:</span>
              <span className="total-amount">
              ${subtotal.toFixed(2)}
              </span>
            </div>
          </div>
        )}
        {event.hasReservableOccurrences &&
          <div className="EventReservation-occurrences">
            <select className='form-control' onChange={this.occurrenceSelected} value={this.selectedOccurrenceId}>
              {event.reservableOccurrences.map(occurrence =>
                <option value={occurrence.id} key={occurrence.id}>{occurrence.displayName}</option>
              )}
            </select>
          </div>

        }
        { !showSeatDetails && !event.event_id &&
          <div className="EventReservation-ticket-types">
            <table className="table">
              <tbody>
              { !event.isFamily &&
                event.ticket_settings && event.ticket_settings.map(ticketSetting =>
                  <tr key={ticketSetting.type}>
                    <td className="td-padding-important">{ticketSetting.type}</td>
                    <td className="td-padding-important">{Formatter.amountFromCents(ticketSetting.amount)}</td>
                    <td className="text-right td-padding-important">
                     <button type="button" className="btn btn-outline-primary btn-sm ticket-btn" disabled={(tickets[ticketSetting.type] ?? 0) <= 0} onClick={() => this.inc(ticketSetting.type, -1)}>–</button>
                     <span className="counter">{tickets[ticketSetting.type] || 0}</span>
                     <button type="button" className="btn btn-outline-primary btn-sm ticket-btn" onClick={() => this.inc(ticketSetting.type, +1)}>+</button>
                    </td>
                  </tr>
                )
              }
                { event.isFamily &&
                  <tr>
                    <td colSpan="3">
                      <h6>Select Family Profile</h6>
                      <Multiselect
                        options={linked_users_json}
                        onSelect={this.onSelect}
                        onRemove={this.onRemove}
                        displayValue="name"
                      />
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
        <div className="EventReservation-action">
          <SmartButtonStub text={event.btn_text || "Reserve"} click={this.reserve} />
          <Link to={`${base}/${event.uid}`} className='btn smart-button'>Cancel</Link>
        </div>
      </div>
    )
  }

  reserve = async () => {
    let { event, base, reloadSmartButtons, action } = this.props
    let { tickets, selectedFamilyMembers, selectedSeats } = this.state
    let { selectedOccurrenceId } = this
    let selectedPlanId = this.props.selectedPlan?.id || null
    let result = ''

    // If there are selected seats, set tickets to an empty array
    if (selectedSeats && selectedSeats.length > 0) {
        tickets = []  // Send empty array in tickets when there are selected seats
    }

    if (event.isShuttle && (!tickets || !Object.values(tickets).some(v => v > 0))) {
      alert('Please select at least one reservation type')
      return
    }

    // Pass the selected seats to the reservation method
    if (action === 'reserve') {
      result = await event.reserve(selectedOccurrenceId || event.id, tickets, selectedFamilyMembers, selectedSeats, {} , selectedPlanId)
    } else if (action === 'modifyReservation') {
      let occurrenceId = event.isShuttle ? event.id : (selectedOccurrenceId || event.id)
      result = await event.modifyReservation(occurrenceId, tickets, selectedFamilyMembers, selectedOccurrenceId)
    }

    if (result) {
      application.go(`${base}/${event.uid}`)
      reloadSmartButtons()
    }
  }

  onSeatSelected = (seat) => {
    let { tickets, selectedSeats } = this.state;

    // Increment the ticket count for the selected seat's category
    tickets[seat.category.label] = (tickets[seat.category.label] || 0) + 1;

    selectedSeats[seat.category.label] = [...(selectedSeats[seat.category.label] || []), seat.seatId];

    this.setState({
      tickets,
      selectedSeats // Update selectedSeats with the new seat
    });
  }

  onSeatDeselected = (seat) => {
    let { tickets, selectedSeats } = this.state;

    // Decrement the ticket count for the deselected seat's category, ensuring it doesn't go below 0
    if (tickets[seat.category.label] > 0) {
      tickets[seat.category.label] -= 1;

      // If the count becomes zero, remove the ticket category from the tickets object
      if (tickets[seat.category.label] === 0) {
        delete tickets[seat.category.label];
      }
    }

    // Remove the deselected seat from the correct category in selectedSeats
    selectedSeats[seat.category.label] = selectedSeats[seat.category.label].filter(selectedSeat => selectedSeat !== seat.seatId);

    // If no seats remain in this category, remove the category from selectedSeats
    if (selectedSeats[seat.category.label].length === 0) {
      delete selectedSeats[seat.category.label];
    }

    this.setState({
      tickets,
      selectedSeats // Update selectedSeats after seat deselection
    });;
  }

  occurrenceSelected = (e) => {
    let { event, base } = this.props
    application.go(`${base}/${event.uid}::reserve:${e.target.value}`)
  }

  onSelect = (selectedList, selectedItem) => {        
    let family_profile_ids = selectedList.map(r => r.id);
    this.setState({ selectedFamilyMembers: family_profile_ids })
  }

  onRemove = (selectedList, removedItem) => {
    let family_profile_ids = selectedList.map(({id}) => ({ id }));
    this.setState({ selectedFamilyMembers: family_profile_ids })
  }

  inc(ticketTypeName, count) {
    let tickets = { ...this.state.tickets, [ticketTypeName]: (this.state.tickets[ticketTypeName] || 0) + count }
    this.setState({ tickets })
  }

  renderCardRequired() {
    return <div className="EventReservation-card-required">
      <p>You need to set up a credit card to reserve events.</p>
      <Link to="/settings/payment" onClick={this.didMovedToCardSettings}>Add a Credit Card</Link>
    </div>
  }
}
